import { render, staticRenderFns } from "./WaitingListContact.vue?vue&type=template&id=4f918a6a&"
import script from "./WaitingListContact.js?vue&type=script&lang=js&"
export * from "./WaitingListContact.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports